/* eslint-disable import/prefer-default-export */
export const COMPARE_OPERATIONS = {
  EQUAL: 'equal',
  GREATER: 'greater',
  GREATER_OR_EQUAL: 'greaterOrEqual',
  LESS: 'less',
  LESS_OR_EQUAL: 'lessOrEqual'
};
